import { downloadRobot, fetchRobot, RobotResponse } from '../../utils/robot';
import { LlmAppSecrets } from '../types';

export type PythonRulesVectorDbRequest = {
  rules: string[];
  model: string;
  provider: string;
  secrets: LlmAppSecrets;
  downloadPath: string;
};

export type PythonRulesVectorDbResponse = {
  dbVectorFilename: string;
};

export async function pythonRulesVectorDbHandler(request: PythonRulesVectorDbRequest) {
  const result = await fetchRobot<RobotResponse & { file?: 'string' }>('api/llm/rules', 'POST', {
    model: request.model,
    provider: request.provider,
    secrets: request.secrets,
    type: 'rules',
    rules: request.rules,
  });

  if (result.success && result.file) {
    const file = await downloadRobot(result.file, request.downloadPath);
    return file;
  } else {
    throw new Error(result.error || 'Unknown error');
  }
}
